import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo/logo_simple.png'


const _hoisted_1 = {
  ref: "root",
  id: "footer",
  class: "footer"
}
const _hoisted_2 = { class: "top-grid" }
const _hoisted_3 = { class: "top-items top-content-primary" }
const _hoisted_4 = { class: "footer-top" }
const _hoisted_5 = { class: "footer__list sp-none" }
const _hoisted_6 = { class: "footer__item" }
const _hoisted_7 = { class: "footer__item" }
const _hoisted_8 = { class: "footer__item" }
const _hoisted_9 = { class: "footer__item" }
const _hoisted_10 = { class: "footer__item" }
const _hoisted_11 = { class: "footer__item" }
const _hoisted_12 = { class: "footer__item" }
const _hoisted_13 = { class: "footer__item" }
const _hoisted_14 = { class: "footer__item" }
const _hoisted_15 = { class: "footer__item" }
const _hoisted_16 = { class: "footer__item" }
const _hoisted_17 = { class: "footer__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  class: "top-inner-img fade-right-out",
                  src: _imports_0
                }, null, -1),
                _createElementVNode("span", { class: "footer-title" }, "CYCLONE GYM", -1)
              ])),
              _: 1
            }),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "footer-adress" }, "東京都葛飾区金町6-4-4 クライスビル1F", -1))
          ]),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: _ctx.$route.path === '/ ' ? '#concept' : '/#concept'
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" コンセプト ")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: _ctx.$route.path === '/ ' ? '#news' : '/#news'
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" お知らせ ")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: _ctx.$route.path === '/ ' ? '#lesson' : '/#lesson'
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" スケジュール ")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: _ctx.$route.path === '/ ' ? '#menu' : '/#menu'
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" クラス紹介 ")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: _ctx.$route.path === '/ ' ? '#price' : '/#price'
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode(" 料金 ")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: _ctx.$route.path === '/ ' ? '#flow' : '/#flow'
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" 入会の流れ ")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createVNode(_component_router_link, {
                to: _ctx.$route.path === '/ ' ? '#qa' : '/#qa'
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode(" よくある質問 ")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_component_router_link, {
                to: _ctx.$route.path === '/ ' ? '#staff' : '/#staff'
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" スタッフ紹介")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_14, [
              _createVNode(_component_router_link, { to: "/Facilittes" }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("施設紹介")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: _ctx.$route.path === '/ ' ? '#info' : '/#info'
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode(" ジム案内")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createVNode(_component_router_link, {
                to: _ctx.$route.path === '/ ' ? '#access' : '/#access'
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode(" アクセス")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createVNode(_component_router_link, { to: "/Contact" }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode(" お問い合わせ ")
                ])),
                _: 1
              })
            ])
          ])
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "footer-copy" }, "Copyright © 2023 CYCLOME GYM All rights reserved.", -1))
      ])
    ])
  ], 512))
}